import '../../index.css';
import React, {useEffect, useState} from "react";
import * as md5 from "md5";
import {instance} from "../../API/API";
import {get_cookie} from "../../helpers/get_cookie";
import {message} from "antd";
import ModeSelector from "./components/ModeSelector";
import {AuthForm} from "./AuthForm";
import Main from "../main/Main";
import GeneralMobile from "../new_reports/GeneralMobile";
import NoAccessComponent from "./components/NoAccessComponent";

const NewAuth = () => {
    const [isAuth, setIsAuth] = useState(false);
    const [user, setUser] = useState(null);
    const [isCheckLoad, setIsCheckLoad] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isReporter, setIsReporter] = useState(false);
    const [currentMode, setCurrentMode] = useState(0);
    const [isPlanningAccess, setIsPlanningAccess] = useState(false);
    const [isStoreAccess, setIsStoreAccess] = useState(false);
    const [isAuthLoader, setIsAuthLoader] = useState(false);
    const [isLogoutLoader, setIsLogoutLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    console.log(user);
    const get_check_request = async () => {
        try {
            setIsCheckLoad(true);
            const check_request = await instance.get(`/main/check.php`, {
                method: 'GET',
                credentials: 'include'
            });
            if (check_request && check_request.data) {
                const isAuthResponse = check_request.data.access || false;
                const userResponse = check_request.data.user || null;
                if (userResponse) {
                    const userRoles = userResponse.data?.roles || [];
                    const isAdmin = userRoles.includes('1');
                    const isReporter = userRoles.includes('3');
                    const isStoreManager = userRoles.includes('6');
                    const isPlanningManager = userRoles.includes('8');
                    setIsReporter(isReporter);
                    setIsAdmin(isAdmin);
                    setIsStoreAccess(isStoreManager);
                    setIsPlanningAccess(isPlanningManager);
                }
                setIsAuth(isAuthResponse);
                setUser(userResponse);
            } else {
                setIsAuth(false);
                setUser(null);
                message.error('Не удалось подтвердить авторизацию', 3);
            }
        } catch (e) {
            console.error('Check auth error:', e.message);
            setIsAuth(false);
            setUser(null);
        } finally {
            setIsCheckLoad(false);
        }
    }

    useEffect(() => {
        get_check_request();
    }, []);

    const submit = async (values) => {
        setIsAuthLoader(true);
        setErrorMessage(null);
        try {
            const passHash = md5(values.password);
            const login = values.username;
            const authResponse = await instance.get(`/main/auth.php`, {
                params: {
                    login,
                    pass: passHash
                }
            });
            if (authResponse && authResponse.data) {
                console.log(authResponse.data);
                if (authResponse.data.data?.auth) {
                    await get_check_request();
                } else {
                    setErrorMessage(authResponse.data.data?.message || 'Проверьте логин и пароль');
                }
            } else {
                setErrorMessage('Ошибка авторизации');
            }
        } catch (e) {
            const errorMsg = e.response?.data?.error || e.message || 'Ошибка авторизации';
            message.error(errorMsg, 3);
            setErrorMessage(errorMsg);
            console.error('Auth error:', e);
        } finally {
            setIsAuthLoader(false);
        }
    };

    const logout = async () => {
        try {
            setIsLogoutLoader(true)
            await instance.post('/main/logout.php', {
                login: get_cookie("login")
            });
        } catch (error) {
            console.error('Error during logout:', error);
        } finally {
            // Очищаем все состояния
            setUser(null);
            setIsAuth(false);
            setIsAdmin(false);
            setIsReporter(false);
            setIsStoreAccess(false);
            setIsPlanningAccess(false);
            setCurrentMode(0);
            setIsLogoutLoader(false)
        }
    };

    if (isCheckLoad) {
        return <div>Загрузка...</div>;
    }

    if (!isAuth) {
        return <AuthForm submit={submit} message={errorMessage} loading={isAuthLoader}/>;
    }

    // Проверяем, есть ли у пользователя хотя бы одна роль
    const hasAnyAccess = isAdmin || isReporter || isPlanningAccess || isStoreAccess;

    if (!hasAnyAccess) {
        return <NoAccessComponent logout={logout}/>;
    }

    if (isReporter && !currentMode && (isAdmin || isStoreAccess || isPlanningAccess)) {
        return <ModeSelector onModeSelect={setCurrentMode}
                             isAdmin={isAdmin}
                             isStoreAccess={isStoreAccess}
                             isPlanningAccess={isPlanningAccess}
        />;
    }

    if ((isAdmin && !isReporter) || (currentMode === 1 || currentMode === 3 || currentMode === 4)) {
        return <Main
            isLogoutLoader={isLogoutLoader}
            exit={logout}
            user={user}
            roles={{isAdmin, isReporter, isPlanningAccess, isStoreAccess}}
        />;
    }

    if ((!isAdmin && isReporter) || (currentMode === 2)) {
        return <GeneralMobile exit={logout} user={user}/>;
    }

    return <NoAccessComponent logout={logout}/>;
}

export default NewAuth;